<template>
  <v-card class="ui-module-card" color="primary">
    <v-card-title>
      <div class="text-h5 font-weight-bold">Documentos</div>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon color="secondary" @click="refrescarDocumentos" :loading="loading" v-bind="attrs" v-on="on">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>Refrescar documentos</span>
      </v-tooltip>
      <v-tabs v-model="selectedTab" color="secondary" fixed-tabs>
        <v-tab key="1" class="font-weight-bold">Vigentes</v-tab>
        <v-tab key="2" class="font-weight-bold">Archivados</v-tab>
      </v-tabs>
    </v-card-title>
    <v-card-text>
      <v-tabs-items v-model="selectedTab" class="transparent">
        <v-tab-item key="1">
          <v-container>
            <v-row v-if="loading">
              <v-col cols="12" align="center">
                <v-progress-circular indeterminate color="secondary" size="64"></v-progress-circular>
                <div class="text-h6 mt-2">Cargando documentos...</div>
              </v-col>
            </v-row>
            <v-row v-else-if="documentosVigentes && documentosVigentes.length > 0">
              <v-col cols="4" v-for="documento in documentosVigentes" :key="documento.id">
                <DocumentoCard
                  class="documento-card"
                  :documento="documento"
                  :openComentariosModal="openComentariosModal"
                  :archiveDocument="archiveDocument"
                  :openEditModal="openEditModal"
                  :archivado="false"
                />
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <v-icon color="primary darken-3" size="256">mdi-folder-alert</v-icon>
                <div class="text-h6">No se encontró ningún documento vigente</div>
              </v-col>
            </v-row>
            <v-row v-if="!loading">
              <v-col cols="12" align="center">
                <TextButton
                  v-if="perfil !== PERFILES['ADMINSITRADOR GENERAL'] && perfil !== PERFILES['Policia']"
                  :to="{ name: getRouteName, params: { id: idPersonal } }"
                >
                  Agregar documento
                </TextButton>
                <agrega-documento-dialog-component :id="idPersonal" v-else></agrega-documento-dialog-component>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <!-- TAB ARCHIVADOS -->
        <v-tab-item key="2">
          <v-container>
            <v-row v-if="loading">
              <v-col cols="12" align="center">
                <v-progress-circular indeterminate color="secondary" size="64"></v-progress-circular>
                <div class="text-h6 mt-2">Cargando documentos...</div>
              </v-col>
            </v-row>
            <v-row v-else-if="documentosArchivados && documentosArchivados.length > 0">
              <v-col cols="4" v-for="documento in documentosArchivados" :key="documento.id">
                <DocumentoCard class="documento-card" :documento="documento" :archivado="true" />
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <v-icon color="grey" size="256">mdi-folder-alert</v-icon>
                <div class="text-h6">No se encontró ningún documento archivado</div>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import AgregaDocumentoDialogComponent from '../../../../views/policia/AgregaDocumentoDialogComponent.vue'
import { DIALOG_TYPES } from '../../../../plugins/dialog-types'
import DocumentoCard from '../../../DocumentoCard.vue'
import TextButton from '../../../base/TextButton.vue'
import { PERFILES } from '@/perfiles.js'

export default {
  components: {
    AgregaDocumentoDialogComponent,
    DocumentoCard,
    TextButton,
  },
  data() {
    return {
      PERFILES,
      selectedTab: 0,
      DIALOG_TYPES,
      loading: false,
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    idPersonal() {
      return this.personal?.idPersonal
    },
    ...mapGetters({
      perfil: 'getPerfil',
      documentosVigentes: 'documento/documentosVigentes',
      documentosArchivados: 'documento/documentosArchivados',
      documentosCargados: 'documento/documentosCargados', // Ahora desde el store
    }),
    getRouteName() {
      if (this.$route.matched.some(({ path }) => path === '/profesionalizacion')) {
        return 'agregaDocumentoPersonal'
      } else if (this.$route.matched.some(({ path }) => path === '/enlace_c3')) {
        return 'agregaDocumentoEnlace'
      } else if (this.$route.matched.some(({ path }) => path === '/enlace')) {
        return 'enlace.agrega_documento_personal'
      } else if (this.$route.matched.some(({ path }) => path === '/personal')) {
        return 'agregaDocumentoRegistroPersonal'
      } else if (this.$route.matched.some(({ path }) => path === '/recursos_humanos')) {
        return 'recursos_humanos.agrega_documento_personal'
      } else {
        return 'policia.agrega_documento_personal'
      }
    },
  },
  async mounted() {
    // Solo cargar si no se han cargado antes
    if (!this.documentosCargados) {
      await this.cargarDocumentos()
    }
  },
  methods: {
    ...mapMutations('documento', ['SET_SELECTED_DOCUMENTO']),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapActions('tipoDocumento', ['fetchTipoDocumento']),
    ...mapActions('documento', ['updateEstatusDocumentoPersonal', 'fetchDocumentoByPersonal']),

    async cargarDocumentos() {
      this.loading = true
      try {
        await this.fetchTipoDocumento()
        if (this.idPersonal) {
          await this.fetchDocumentoByPersonal(this.idPersonal)
        }
      } finally {
        this.loading = false
      }
    },

    async refrescarDocumentos() {
      await this.cargarDocumentos()
    },

    openComentariosModal(documento) {
      this.SET_DIALOG({ ...DIALOG_TYPES.COMENTARIOS_DOCUMENTOS, props: { documento } })
    },
    openEditModal(documento) {
      this.SET_SELECTED_DOCUMENTO(documento)
      this.SET_DIALOG(DIALOG_TYPES.EDITAR_DOCUMENTO_REGISTRADO)
    },

    async archiveDocument(documento) {
      await this.updateEstatusDocumentoPersonal({
        fk_idPersonal: this.idPersonal,
        iddocumentosPersonal: documento.iddocumentosPersonal,
        fk_idEstatus: 4,
      })
      await this.fetchDocumentoByPersonal(this.idPersonal)
    },
  },
}
</script>
